const STAND = "stand";
const HOLDING = "holding";
const FLYING = "flying";
const DESTROYED = "destroyed";
const DISABLED = "disabled";

export const Rarity = {
    RARE: 'rare',
    COMMON: 'common',
    TRASH: 'trash'
}
const WALKING = "walking";

function throwing(x, z, vx, vz) {
    const gy = -200;
    let gm = 1;
    let blocked = false;

    return {
        flying: true,

        get x() { return x; },
        get z() { return z; },
        get vx() { return vx; },

        blocked() {
            gm = 2;
            blocked = true;
            vx = 0;
        },

        update(ms) {
            x += vx / 1000 * ms;
            vz += gy * gm / 1000 * ms;
            z += vz / 1000 * ms;
            if (z <= 0) {
                this.flying = false;
                game.sounder.play('put-2');
                z = 0;
            }
        },

        get scale() {
            return 1 + Math.pow(Math.max(z - 12, 0) / 12, 4);
        }
    }
}


export default class BaseItem extends Phaser.Sprite {
    constructor(x, y, frame, key) {
        super(game, x, y, frame, key);
        this.anchor.set(0.5, 0.5);
        game.physics.arcade.enableBody(this);
        this.body.setSize(this.constructor.width, this.constructor.height, 0, this.height - this.constructor.height);
        this.body.immovable = true;

        this.shadow = game.add.sprite(0, (this.height / 2) - 5, "items", "shadow.png");
        this.shadow.width = this.width;
        this.addChild(this.shadow);
        this.shadow.anchor.set(0.5, 0.5);

        this.state = STAND;
        this.flyTarget = {
        };

    }

    _renderWebGL(renderSession, matrix) {
        // if the sprite is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.alpha <= 0 || !this.renderable) return;

        //  They provided an alternative rendering matrix, so use it
        var wt = this.worldTransform;
        if (matrix)
        {
            wt = matrix;
        }

        //  Render children!
        for (var i = 0; i < this.children.length; i++)
        {
            this.children[i]._renderWebGL(renderSession, wt);
        }
        renderSession.spriteBatch.render(this);

    }

    explode() {
        this.state = DESTROYED;
        this.shadow.visible = false;
        this.body.velocity.set(0);
        //todo: animation explosion
        this.destroy();
    }

    setDestroyed() {
        this.state = DESTROYED;
        this.shadow.visible = false;
        this.body.velocity.set(0);
        game.add.tween(this).to({ rotation: Math.PI }, 500, null, true);
        game.add.tween(this.scale).to({ x: 0.5, y: 0.5 }, 500, null, true);
        game.add.tween(this).to({ alpha: 0 }, 500, null, true).onComplete.addOnce(() => {
            this.destroy();
        })
    }

    get type() {
        return this.constructor.type;
    }

    get rare() {
        return this.rarity === Rarity.RARE;
    }

    get isTrash() {
        return this.rarity === Rarity.TRASH;
    }

    get holding() {
        return this.state === HOLDING;
    }

    get walking() {
        return this.state === WALKING;
    }

    get flying() {
        return this.state === FLYING;
    }

    get standing() {
        return this.state === STAND;
    }

    get destroying() {
        return this.state === DESTROYED;
    }

    get disabled() {
        return this.state === DISABLED;
    }

    get canBeBurnedRightNow() {
        return this.isAvailable;
    }

    get isAvailable() {
        return this.state === HOLDING || this.state === STAND || this.state === FLYING || this.state === WALKING;
    }

    get canBeHandled() {
        return this.state === STAND || this.state === WALKING;
    }

    setWalking() {
        this.state = WALKING;
        this.shadow.visible = true;
    }

    setHolded() {
        this.state = HOLDING;
        this.shadow.visible = false;
        if (this.constructor.phrases && this.constructor.phrases.pick) {
            let p = game.rnd.pick(this.constructor.phrases.pick);
            if (p && p.length) {
                game.gameState.addLog(this.constructor.label + "> " + p);
            }
        }
    }

    onTouchBy(anotherItem) {
        if (anotherItem.flying) {
            /*let spd = 0.5 * this.mass / anotherItem.mass;
            let newSpeed = anotherItem.body.speed * spd;
            this.setThrown(anotherItem.direction, newSpeed);*/
        }
    }

    resetStateAfterFly() {
        this.shadow.y = this.shadow.originalY;
        this.setStand();
        if (this.constructor.phrases && this.constructor.phrases.land) {
            let p = game.rnd.pick(this.constructor.phrases.land);
            if (p && p.length) {
                game.gameState.addLog(this.constructor.label + "> " + p);
            }
        }

    }

    setThrown(direction, speed, baseZ = 0) {
        this.state = FLYING;
        this.shadow.visible = true;
        let x = this.x;
        let y = this.y + baseZ;
        //if (direction === 'left' || direction === 'right')
        let model = throwing(0, baseZ, speed, 40);
        this.direction = direction;
        this.shadow.originalY = this.shadow.y;
        this.flyUpdate = () => {
            model.update(game.time.physicsElapsedMS);
            this.body.velocity.set(0);
            if (this.body.blocked[direction] || this.body.touching[direction]) {
                model.blocked();
            }
            switch (direction) {
                case 'right':
                    this.body.velocity.set(model.vx, 0);
                    this.body.y = y - model.z;
                    this.shadow.y = model.z;
                    break;
                case 'left':
                    this.body.velocity.set(-model.vx, 0);
                    this.body.y = y - model.z;
                    this.shadow.y = model.z;
                    break;
                case 'up':
                    this.body.velocity.set(0, -model.vx);
                    this.scale.set(model.scale);
                    this.body.x = x;
                    this.shadow.y = model.z;
                    break;
                case 'down':
                    this.body.velocity.set(0, model.vx);
                    this.scale.set(model.scale);
                    this.body.x = x;
                    this.shadow.y = model.z;
                    break;

            }
            if (!model.flying) {
                this.resetStateAfterFly();
            }
        }
    }

    setStand() {
        this.body.velocity.set(0);
        this.state = STAND;
        this.shadow.visible = true;
    }

    setDisabled() {
        this.body.velocity.set(0);
        this.state = DISABLED;
        this.scale.set(1);
        this.shadow.visible = false;
        this.body.destroy();
    }

    get mass() {
        return 10;
    }

    static get electronic() { return false; }
    static get rarity() { return Rarity.COMMON; }

    update() {
        if (!game.shipBounds.contains(this.centerX, this.centerY)) {
            this.setDestroyed();
            game.add.tween(this).to({ x: -100 }, 500, null, true);
        }

        if (!game.gameState.canUpdateItem()) return;
        if (this.state === FLYING) {
            this.flyUpdate();
        }
    }

    jump() {
        if (this.state === STAND || this.state === WALKING) {
            let y = this.y;
            let shadowY = this.shadow.y;
            game.add.tween(this).to({y: y-15}, 200, Phaser.Easing.Bounce.In, true, 0, 2, true);
            game.add.tween(this.shadow).to({y: shadowY+15}, 200, Phaser.Easing.Bounce.In, true, 0, 2, true);
        }
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/base_item.js